export const categories = [
  "Coat",
  "Pant & Trousers",
  "T-shirt & Shirts",
  "Belt & Accessories",
  "Sweater & Inners",
  "Jacket & Outer",
  "Slipper & Shoes",
  "Cap & Beanie",
  "Shorts",
  "Sets"
];
